<template>
  <section class="special-gifts-intro">
    <v-container class="px-0">
      <div class="special-gifts-intro__content d-flex flex-column align-center text-center">
        <div class="special-gifts-intro__heading">
          <h1 class="special-gifts-intro__title color-gray" v-html="pageContent.title"></h1>
          <h3 class="special-gifts-intro__subtitle size1 text-uppercase mx-auto" v-html="pageContent.subtitle"></h3>
        </div>
    
        <div class="special-gifts-intro__text" :class="[isWindowMD ? 'size1' : 'size2']" v-html="pageContent.text"></div>
    
        <a :href="pageContent.file" download class="special-gifts-intro__link d-flex align-center">
          <span class="h6 color-golden flex-shrink-0">загрузить презентацию</span>
		      <svgicon name="download" class="flex-shrink-0" :original="true"/>
        </a>
  
        <v-img class="special-gifts-intro__banner" :src="pageContent.banner" :contain="isWindowMD" :eager="true"></v-img>
      </div>
    </v-container>
  </section>
</template>

<script>

export default {
  name: 'special-gifts-intro',
  data() {
    return {

    }
  },
  computed: {
    isWindowMD() {
      return this.$store.getters.isWindowMD;
    },
    page() {
      return this.$store.state.page.SpecialGiftsController.page;
    },
    pageContent() {
      const [title, subtitle] = this.page.PREVIEW_TEXT.split('\r\n');
      const text = this.page.DETAIL_TEXT;
      const banner = this.page.DETAIL_PICTURE;
      const file = this.page.FILE;

      return {title, subtitle, text, banner, file}
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss">
.special-gifts-intro {
  & > .container {
    padding-top: 48px;
    padding-bottom: 24px;

    @include up($md) {
      padding-top: 53px;
      padding-bottom: 53px;
    }
  }
  
  &__content {
    gap: 30px;
    
    @include up($md) {
      gap: 48px;
    }
  }

  &__banner {
    width: 100%;
    height: 167px;
    
    @include up($md) {
      height: auto;
    }
  }

  &__heading {
    margin-bottom: 24px;
    
    @include up($md) {
      margin-bottom: 0px;
    }
  }

  &__text {
    max-width: 76%;
    letter-spacing: $ls-1;
    
    @include up($md) {
      max-width: 806px;
      margin-bottom: 36px;
    }
  }

  &__title {
    margin-bottom: 20px;
  }

  &__subtitle {
    font-weight: bold;
    max-width: 70%;

    @include up($md) {
      max-width: 100%;
    }
  }

  &__link {
    gap: 10px;
    border-bottom: 1px solid $golden;
    padding-bottom: 2px;

    .svg-icon {
      width: 18px;
      height: 18px;
    }

    &:hover {
      border-color: transparent;
      opacity: 1;
    }
  }
}
</style>